/**
 * @fileoverview ConnectionUtil util
 */
'use strict';
// Library Import
import _ from 'lodash';
// Config Import
import AppConfig from '../AppConfig';
// Connection Import
import HTTP from '../connection/HTTP';
// Util Import
import * as ConstUtil from './ConstUtil';
import * as LogUtil from './LogUtil';

/**
 * ConnectionUtil
 *
 * @class ConnectionUtil
 */
class ConnectionUtil {
  constructor() {}

  /**
   * HTTPインスタンス生成
   *
   * @param {Number} timeout タイムアウト時間
   * @param {Object} headers ヘッダー情報
   * @memberof ConnectionUtil
   */
  createInstance(timeout, headers) {
    // headersが空の場合
    if (_.isEmpty(headers)) {
      headers = {
        // アクセストークン
        [ConstUtil.Common.REQUEST_HEADER_KEYS
          .X_LOGIPULL_TOKEN]: localStorage.getItem(
          ConstUtil.Common.STORAGE_KEY.TOKEN
        ),
        'Content-Type': 'application/json; charset=utf-8',
        'Cache-Control': 'no-cache',
        'Access-Control-Allow-Headers': '*'
      };
    }

    // タイムアウト時間が未設定の場合
    if (_.isEmpty(timeout)) {
      // デフォルト設定
      timeout = ConstUtil.Common.TIMEOUT.DEFAULT;
    }

    // HTTPインスタンス生成
    HTTP.createInstance(
      AppConfig.accessPoint + AppConfig.apiPortNumber,
      headers,
      timeout
    );
  }

  /**
   * API呼び出し
   *
   * @param {Object} api API情報
   * @param {Object} request リクエストデータ
   * @param {Function} callback 呼び出し元のコールバック処理
   * @param {Number} timeout タイムアウト時間
   * @memberof ConnectionUtil
   */
  callAPI(api, request, callback, timeout) {
    // 引数チェック
    if (request.headers === undefined) {
      callback(new Error('[ERROR] no header information in the request'), null);
      return;
    }
    if (request.data === undefined) {
      callback(new Error('[ERROR] no data information in the request'), null);
      return;
    }

    // HTTPインスタンス生成
    this.createInstance(timeout, request.headers);

    // 通信処理
    HTTP.connect(api, request.data, function(err, res) {
      if (err) {
        // 異常時
        callback(err, null);
        return;
      }
      // 正常時
      callback(null, res);
      return;
    });
  }
}
export default new ConnectionUtil();



// WEBPACK FOOTER //
// ./src/js/util/ConnectionUtil.jsx